function revenueDataKey(){
  const lsTimestamp = $('#add-revenue-form').data('local-storage-timestamp')
  return `revenue-data-${lsTimestamp}`
}

function setProductUnitPrice(isSmall) {
  let selectedCodeSelect = '#selected-code';
  let unitSellingPriceInput = '#unit-selling-price';

  if (isSmall === true) {
    selectedCodeSelect = selectedCodeSelect + "-sm"
    unitSellingPriceInput = unitSellingPriceInput + "-sm"
  }

  const isProductOrService = $(`${selectedCodeSelect} option:selected`).data('is-product-or-service');
  const unitSellingPrice = $(`${selectedCodeSelect} option:selected`).data('unit-selling-price')

  if (isProductOrService == true) {
    $(unitSellingPriceInput).val(unitSellingPrice)
  } else {
    $(unitSellingPriceInput).val('')
  }
}

function addRevenueCode(isSmall) {
  let addBtnID = "#add-revenue-code";
  let selectedCodeID = '#selected-code';
  let unitSellingPriceInputID = '#unit-selling-price';

  if (isSmall) {
    addBtnID = `${addBtnID}-sm`;
    selectedCodeID = `${selectedCodeID}-sm`;
    unitSellingPriceInputID = `${unitSellingPriceInputID}-sm`;
  }

  $(addBtnID).click(async function () {
    const codeName = $(`${selectedCodeID} option:selected`).data('name');
    const codeId = $(`${selectedCodeID} option:selected`).val();
    const elementId = `selected-code-${codeId}`;

    if ($("#" + elementId).length > 0) {
      toastNotification('error', `Product Already Added`);
    } else {
      const quantity = getProductQuantity(isSmall)
      const unitSellingPrice = removeCommas($(unitSellingPriceInputID).val());

      if (isNaN(unitSellingPrice) || allWhiteSpaces(unitSellingPrice)) {
        toastNotification('error', 'Quantity or Amount is not valid');
      } else {

        const gasRefillStatus = $('.revenue-select option:selected').data('isGasRefill')

        const revenueItem = {
          key: codeId,
          code_name: codeName,
          code_id: codeId,
          unit_selling_price: unitSellingPrice,
          quantity: quantity,
          is_gas_refill: gasRefillStatus,
        }

        storeItemInLocalStorage(revenueItem, revenueDataKey())
        setRevenueDataRows()

        console.log(localStorage.getItem(revenueDataKey()))
        
        if (gasRefillStatus === true){
          $('#cylinder-return-required').val('yes')
        }
      }
    }
  });
}

function removeAddedProduct() {
  $("table").on('click', '.remove-code', function () {
    const codeId = $(this).data('code-id');
    const uniquekey = codeId
    const txt = $("#selected-code-" + uniquekey).text();
    const gasRefillStatus = $(this).data('is-gas-refill')

    if (gasRefillStatus === true){
      $('#cylinder-return-required').val('no')
    }

    toastNotification('info', 'Removed Code: ' + txt);
    $(this).closest("tr").remove();
    removeItemFromLocalStorage(uniquekey, revenueDataKey());
    setRevenueDataRows()
    setProductUnitPrice(false);
    setProductUnitPrice(true);
    setLastPrice()
  });
}

function removeTotalRow() {
  const row = document.getElementById('revenue-total');

  if (row === null || row === undefined) {
    return
  }

  row.parentNode.removeChild(row);
}

function calculateRevenueQuantity() {
  const data = JSON.parse(localStorage.getItem(revenueDataKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return 0
  }

  let totalQuantity = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + parseFloat(curValue.quantity)
  }, 0)

  return totalQuantity
}

function calculateRevenueTotal() {
  const data = JSON.parse(localStorage.getItem(revenueDataKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return 0
  }

  let totalAmount = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + (parseFloat(curValue.unit_selling_price) * parseFloat(curValue.quantity))
  }, 0)

  return totalAmount
}

function setLastPrice(isSmall=false){
  let selectedCodeID = '#selected-code'
  let unitSellingPriceInputID = '#unit-selling-price'

  if (isSmall){
    selectedCodeID = '#selected-code-sm'
    unitSellingPriceInputID = '#unit-selling-price-sm'
  }

  const codeId = $(`${selectedCodeID} option:selected`).val();
  const sellingPriceInput = $(unitSellingPriceInputID);

  const customerId = $(`select[name="revenue[customer_id]"] option:selected`).val()

  if (customerId === "0"){
    return
  }

  $.ajax({
    type: "post",
    url: `/last_price/${customerId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    data: { code_id: codeId },
    success: function (data) {
      console.log(data.last_price)
      if (data.last_price){
        sellingPriceInput.val(data.last_price)
      }else{
        setProductUnitPrice(false);
        setProductUnitPrice(true);
      }
    },
    error: function (data) {
      console.log('An error occurred.');
      console.log(data);
    },
  });

}

function setInitialRevenueData() {
  localStorage.removeItem(revenueDataKey())
  const revenueId = $('#add-revenue-form input[name="revenue[revenue_id]"').val()
  const action = $('#add-revenue-form input[name="revenue[revenue_action]"').val()
  console.log(action)

  if (action === 'create' || revenueId === null || revenueId === undefined) {
    return
  }

  $.ajax({
    type: "post",
    url: `/revenue_details/${revenueId}`,
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      localStorage.setItem(revenueDataKey(), JSON.stringify(data))
      setRevenueDataRows()
      // localStorage.removeItem(revenueDataKey())
    },
    error: function (data) {
      $('#add-revenue-form input[name="commit"]').prop("disabled", false)
      console.log('An error occurred.');
      console.log(data);
    },
  });

}

function setRevenueDataRows() {
  const revenueData = JSON.parse(localStorage.getItem(revenueDataKey()))
  console.log(revenueData)

  if (revenueData === null || revenueData === undefined) {
    console.log('ERROR')
    return
  }

  // remove current content
  $(".revenue-codes").empty()

  // set data rows
  $.each(revenueData, function (key, revenueDetails) {
    const codeName = revenueDetails.code_name
    const quantity = revenueDetails.quantity
    const unitSellingPrice = revenueDetails.unit_selling_price
    const codeId = revenueDetails.code_id
    const elementId = codeId

    $(".revenue-codes").append(
      `<tr>
        <td class='code' id='${elementId}'>${codeName}</td>
        <td class='text-right'>${numberWithCommas(quantity)}</td>
        <td class='code-unit-selling-price text-right'>${numberWithCommas(unitSellingPrice)}</td>
        <td class='code-total-amount text-right'>${numberWithCommas(quantity * unitSellingPrice)}</td>
        <td>
          <a href='javascript:;' class='remove-code' data-code-id='${codeId}'
            data-code-name='${codeName}' data-is-gas-refill='${revenueDetails.is_gas_refill}'
          >
            <i class='fa fa-minus-circle' style='font-size: 14px; margin-left: 15px; color: red'></i>
          </a>
        </td>
      </tr>`
    );
  })

  const totalAmount = numberWithCommas(calculateRevenueTotal())
  const totalQuantity = numberWithCommas(calculateRevenueQuantity())

  let totalTitle = "TOTAL"

  if ($('body').data('app-locale') == 'sw'){
    totalTitle = 'JUMLA KUU'
  }

  // set total row
  $(".revenue-codes").append(
    `<tr id='revenue-total'>
      <td><strong>${totalTitle}</strong></td>
      <td class='total-quantity text-right'>${totalQuantity}</td>
      <td></td>
      <td class='total-sale text-right'>
        <strong>${totalAmount}</strong>
      </td>
      <td></td>
    </tr>`)

  $('input[name="revenue[amount]"]').val(totalAmount)
  $('input[name="revenue[quantity]"]').val(totalQuantity)


  // setTotalAmount();
  $('#unit-selling-price').closest('.form-group').removeClass('has-success');
}

function submitRevenueData() {
  $('#submit-ajax-form-btn').click(function () {
    disableSubmit()
    const revenueType = $('#add-revenue-form input[name="revenue[revenue_type]"]').val()

    let errorString = [];

    if (isEmpty($('#revenue-transaction-date').val())) {
      errorString.push(' Transaction date cannot be blank');
    }

    const revenueData = JSON.parse(localStorage.getItem(revenueDataKey()))

    if (revenueData === null ||
      revenueData === undefined ||
      (Array.isArray(revenueData) && revenueData.length === 0)) {
      errorString.push('Product Items not added')
    }

    const paymentOptions = getPaymentOptionsStorage()

    if (revenueType !== 'credit') {
      if (paymentOptions === null ||
        paymentOptions === undefined ||
        (Array.isArray(paymentOptions) && paymentOptions.length === 0)) {
        errorString.push('Payment option amount not set')
      }
    }

    if (errorString.length > 0) {
      toastNotification('error', errorString.join(','))
    } else {
      $('#spinner-modal').modal('show');

      const postUrl = $('#add-revenue-form').attr('action')
      const redirectUrl = postUrl
      const paymentOptions = getPaymentOptionsStorage()
      const createdAt = $('#add-revenue-form input[name="revenue[created_at]"]').val()
      const description = $('#add-revenue-form textarea[name="revenue[description]"]').val()
      const cashSourceId = $(`select[name="revenue[cash_source_id]"] option:selected`).val()
      const customerId = $(`select[name="revenue[customer_id]"] option:selected`).val()
      const amount = $('#add-revenue-form input[name="revenue[amount]"]').val()
      const cylinderNotReturned = $('#cylinder-not-returned').is(':checked')
      const cylinderReturnRequired = $('#cylinder-return-required').val()

      let action = "post"

      if ($('#add-revenue-form input[name="revenue[revenue_action]"').val() === 'update') {
        action = "patch"
      }

      $.ajax({
        type: action,
        url: postUrl,
        headers: {
          'X-CSRF-Token': csrfToken()
        },
        data: {
          revenue_data: revenueData,
          payment_options: paymentOptions,
          revenue: {
            created_at: createdAt,
            revenue_type: revenueType,
            description: description,
            customer_id: customerId,
            cash_source_id: cashSourceId,
            amount: amount,
            cylinder_not_returned: cylinderNotReturned,
            cylinder_return_required: cylinderReturnRequired
          }
        },
        dataType: "json",
        success: function (data) {
          removePaymentOptionData()
          localStorage.removeItem(revenueDataKey())
          window.location.replace(redirectUrl)
          console.log(data)
        },
        error: function (data) {
          disableSubmit()
          console.log('An error occurred.');
          console.log(data);
        },
      });
    }
  });
}

function showGasRefillCheckBox(selectID){
  const gasRefillStatus = $(`#${selectID} option:selected`).data('isGasRefill')

  if (gasRefillStatus === true){
    $('.gas-cylinder-returned').show()
  }else{
    $('.gas-cylinder-returned').hide()
  }
}

$(document).ready(function () {

  setProductUnitPrice(false);
  setProductUnitPrice(true);

  $('#selected-code').change(function () {
    setProductUnitPrice(false);
    setLastPrice()
    setStockQuantity('#selected-code','#quantity-info')
  });

  $('#selected-code-sm').change(function () {
    setProductUnitPrice(true);
    setLastPrice(true)
    setStockQuantity('#selected-code-sm','#quantity-info-sm')
  });

  // Add Codes Functionality
  if ($('#add-revenue-form').length > 0) {

    setInitialRevenueData()
    setLastPrice()
    setLastPrice(true)
    setStockQuantity('#selected-code','#quantity-info')
    setStockQuantity('#selected-code-sm','#quantity-info-sm')

    if ($('.code-amount-div').length > 0) {
      checkAmount('.code-amount', '.code-amount-div');
    }

    if ($('.code-amount-div-sm').length > 0) {
      checkAmount('.code-amount-sm', '.code-amount-div-sm');
    }

    $('select[name="revenue[customer_id]"]').change(function(){
      setLastPrice()
      setLastPrice(true)
    })

    // big screens
    addRevenueCode(false)

    // for small screens
    addRevenueCode(true)

    // remove added item
    removeAddedProduct()

    submitRevenueData()
    clearFailedSubmit('#add-revenue-form')

    showGasRefillCheckBox('selected-code')
    showGasRefillCheckBox('selected-code-sm')

    $('.revenue-select').change(function (e) {
      const selectID = e.target.id
      showGasRefillCheckBox(selectID)
    })
  }
});
